import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ModalController } from 'ionic-angular';
import { DIC } from '../dic';
import { GN } from '../../gn';
import * as moment from 'moment';
import { EditjobsPage } from '../settings/jobs/editjobs';
import { AddtickedPage } from './addticked';


/**
 * Generated class for the ViewtickedPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-viewticked',
  templateUrl: 'viewticked.html',
})
export class ViewtickedPage {
  loadingData: boolean = false
  tickets = []
  docs = []


  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public alertCtrl: AlertController, public modalCtrl: ModalController) {
  }

  ionViewDidLoad() {
    this.loadData()
    console.log('ionViewDidLoad ViewtickedPage');
  }

  loadData() {
    this.loadingData = true
    var _that = this
    this.gn._Post('/api/gn/getTicket', { uid: this.gn.crypt(this.gn.user.UserId) }, function (_data) {
      console.log(_data, 'daj data da vidam')
      for (let i = 0; i < _data.ticket.length; i++) {
        _data.ticket[i].datetime = moment(_data.ticket[i].datetime).format(_that.gn.user.DFormat) + ' ' + moment(_data.ticket[i].datetime).format(_that.gn.user.TFormat)
      }
      _that.tickets = _data.ticket
      _that.docs = _data.docs
      _that.loadingData = false
    })
  }



  deleteTickets(id: number, name: string, idx: number) {
    var _that = this;
    let alert = _that.alertCtrl.create({
      title: _that.dic.l["deleteticket"],
      subTitle: _that.dic.l["areyouwantodellTicket"] + ' ' + name,
      buttons: [
        {
          text: _that.dic.l['ok'],
          handler: data => {
            _that.gn.loadWaiting();
            this.gn._Post('/api/gn/delTicket', { id: this.gn.crypt(id) }, function (_data) {
              _that.gn.loaderWaiting.dismiss();
              _that.tickets.splice(idx, 1);
            })
          }
        },
        {
          text: _that.dic.l['cancel'],
          role: 'cancel'
        }
      ]
    });
    alert.present();
  }

  addTicket() {
    var _that = this
    let modal = this.modalCtrl.create(AddtickedPage, {
      ti: { id: -1 }, cb: function () {
        // _that.gn.loadWaiting();

        _that.loadData()
        // _that.gn.loaderWaiting.dismiss();

      }
    });
    modal.present();
  }

  editTicket(_u) {
    console.log(_u.id, 'daj da vidam u id')
    var documents = []
    for (let i = 0; i < this.docs.length; i++) {
      if (_u.id == this.docs[i].ticketid) {
        documents.push(this.docs[i])
      }
    }
    console.log(documents, 'documents documents documents documents')
    var _that = this
    let modal = this.modalCtrl.create(AddtickedPage, {
      ti: _u, doc: documents, cb: function () {
        // _that.gn.loadWaiting();

        _that.loadData()

        // _that.gn.loaderWaiting.dismiss();

      }
    });
    modal.present();

  }




}



// WEBPACK FOOTER //
// ./src/pages/ticket/viewticked.ts